@if (isNative) {
    <div class="native form-input" [class.error]="!isValid">
        <label>{{ label }}</label>
        <select class="form-control w-100"
                (change)="inputChange()"
                [disabled]="disabled"
                [(ngModel)]="value"
                [required]="required">
            @if (optionAddNull) {
                <option [value]="null">{{ ('General.None' | trans) }}</option>
            }
            @if (options) {
                @for (option of options; track option[optionValue]) {
                    <option [value]="option[optionValue]">
                        @if (optionLabelTranslate) {
                            {{ (option[optionLabel]| trans) }}
                        } @else {
                            {{ option[optionLabel] }}
                        }
                    </option>
                }
            }
        </select>
        @if (!isValid) {
            <div class="form-input-validation">
                <div class="form-input-notes-left">{{ (errorMessage | trans) }}</div>
            </div>
        }
    </div>
} @else {
    <div class="form-input" [class.error]="!isValid">
        <cm-select [attr.data-label]="label"
                   [disabled]="disabled"
                   [attr.required]="required"
                   [value]="value"
                   [attr.data-more-info]="hint ? hint : null"
                   [attr.data-error]="errorMessage ? (errorMessage | trans) : null"
                   [attr.readonly]="readonly ? true : null"
                   (cm-option-clicked)="value = $event.detail.value; inputChange()"
                   (cm-option-checkbox-clicked)="updateArray($event.detail.value)">
            @if (optionAddNull) {
                <cm-option slot="option"
                           [value]="null"
                           [attr.data-display]="('General.None' | trans)">
                </cm-option>
            }
            @if (options) {
                @for (option of options; track option[optionValue]) {
                    @if (!isMultiselect) {
                        @if (optionLabelTranslate) {
                            <cm-option slot="option"
                                       [attr.value]="option[optionValue]"
                                       [attr.data-display]="(option[optionLabel]| trans)"
                                       [attr.data-display-description]="optionDescription ? (option[optionDescription] | trans) : null"
                                       [attr.disabled]="option[optionDisabled] ? true : null">
                            </cm-option>
                        } @else {
                            <cm-option slot="option"
                                       [attr.value]="option[optionValue]"
                                       [attr.data-display]="option[optionLabel]"
                                       [attr.data-display-description]="optionDescription ? option[optionDescription] : null">
                            </cm-option>
                        }
                    } @else {
                        @if (optionLabelTranslate) {
                            <cm-select-option-checkbox slot="option"
                                                       [attr.value]="option[optionValue]"
                                                       [attr.data-display]="(option[optionLabel]| trans)">
                            </cm-select-option-checkbox>
                        } @else {
                            <cm-select-option-checkbox slot="option"
                                                       [attr.value]="option[optionValue]"
                                                       [attr.data-display]="option[optionLabel]">
                            </cm-select-option-checkbox>
                        }
                    }
                }
            }
        </cm-select>
    </div>
}
